module.exports = __webpack_public_path__ + "img/resource-yellow.d1455d84.png";